import { SupportDeviceModel } from "./support-device-model";

export enum DeviceFeatures {
    // Device Platform
    PLATFORM_OPENWRT = "PLATFORM_OPENWRT",
    PLATFORM_THIRD_PARTY = "PLATFORM_THIRD_PARTY",
    PLATFORM_ROUTER = "PLATFORM_ROUTER",
    PLATFORM_POWER_SWITCH = "PLATFORM_POWER_SWITCH",

    // Device Router Special Model
    ROUTER_MODEL_6200_WZL = "ROUTER_MODEL_6200_WZL",
    ROUTER_MODEL_6800_RUL = "ROUTER_MODEL_6800_RUL",
    ROUTER_MODEL_8920 = "ROUTER_MODEL_8920",

    // Device Action
    ACTION_ALERT_POLICY = "ACTION_ALERT_POLICY",

    // Device Command
    COMMAND_DIAGNOSTIC_TOOL = "COMMAND_DIAGNOSTIC_TOOL",

    // Configuration Platform
    CONFIG_LAGACY_PLATFORM = "CONFIG_LAGACY_PLATFORM",
    CONFIG_LAGACY_8920_PLATFORM = "CONFIG_LAGACY_8920_PLATFORM",

    // Device Module
    MODULE_7516 = "MODULE_7516",

    // Device Function
    FUNCTION_GPS = "FUNCTION_GPS",
    FUNCTION_5G_NR = "FUNCTION_5G_NR",
    FUNCTION_MULTIPLE_WAN = "FUNCTION_MULTIPLE_WAN",
    FUNCTION_SIGNAL = "FUNCTION_SIGNAL",
    FUNCTION_WI_FI = "FUNCTION_WI_FI",
    FUNCTION_5G_WI_FI = "FUNCTION_5G_WI_FI",
    FUNCTION_SFP = "FUNCTION_SFP",
    FUNCTION_EWAN = "FUNCTION_EWAN",
    FUNCTION_SECOND_EWAN = "FUNCTION_SECOND_EWAN",
    FUNCTION_4G_LTE = "FUNCTION_4G_LTE",
    FUNCTION_SECOND_4G_LTE = "FUNCTION_SECOND_4G_LTE",
    FUNCTION_WIRELESS_CLIENT = "FUNCTION_WIRELESS_CLIENT",
    FUNCTION_VPN = "FUNCTION_VPN",
    FUNCTION_VOIP = "FUNCTION_VOIP",
    FUNCTION_HOTSPOT = "FUNCTION_HOTSPOT",
    FUNCTION_FTP = "FUNCTION_FTP",
    FUNCTION_SERIAL_PORT_1 = "FUNCTION_SERIAL_PORT_1",
    FUNCTION_SERIAL_PORT_2 = "FUNCTION_SERIAL_PORT_2",
    FUNCTION_3G = "FUNCTION_3G",

    // Device Config Function
    CONFIG_FUNCTION_GPS_RMC_ONLY = "CONFIG_FUNCTION_GPS_RMC_ONLY",
    CONFIG_FUNCTION_GPS_TRACKING = "CONFIG_FUNCTION_GPS_TRACKING",
    CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE = "CONFIG_FUNCTION_EWAN_MULTIPLE_SERVICE",
    CONFIG_FUNCTION_EWAN_BANDWIDTH = "CONFIG_FUNCTION_EWAN_BANDWIDTH",
    CONFIG_FUNCTION_EWAN_BRIDGE_MODE = "CONFIG_FUNCTION_EWAN_BRIDGE_MODE",
    CONFIG_FUNCTION_5G_NR_NSA_BAND = "CONFIG_FUNCTION_5G_NR_NSA_BAND",
    CONFIG_FUNCTION_PHYSICAL_PORTS = "CONFIG_FUNCTION_PHYSICAL_PORTS",
    CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1 = "CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_1",
    CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2 = "CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_2",
    CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3 = "CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_3",
    CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4 = "CONFIG_FUNCTION_PHYSICAL_PORTS_LAN_4",
    CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1 = "CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_1",
    CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_2 = "CONFIG_FUNCTION_PHYSICAL_PORTS_WLAN_2",
    CONFIG_FUNCTION_ETHERNET_PORTS = "CONFIG_FUNCTION_ETHERNET_PORTS",
    CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1 = "CONFIG_FUNCTION_ETHERNET_PORTS_LAN_1",
    CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2 = "CONFIG_FUNCTION_ETHERNET_PORTS_LAN_2",
    CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3 = "CONFIG_FUNCTION_ETHERNET_PORTS_LAN_3",
    CONFIG_FUNCTION_WI_FI_STATION_NUMBER = "CONFIG_FUNCTION_WI_FI_STATION_NUMBER",
    CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE = "CONFIG_FUNCTION_WI_FI_ENTERPRISE_SECURITY_TYPE",
    CONFIG_FUNCTION_DUAL_SIM = "CONFIG_FUNCTION_DUAL_SIM",
    CONFIG_FUNCTION_TRIPLE_SIM = "CONFIG_FUNCTION_TRIPLE_SIM",
    CONFIG_FUNCTION_E_SIM = "CONFIG_FUNCTION_E_SIM",
    CONFIG_FUNCTION_LAN_DESCRIPTION_NONE = "CONFIG_FUNCTION_LAN_DESCRIPTION_NONE",
    CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1 = "CONFIG_FUNCTION_LAN_DESCRIPTION_LAN1",
    CONFIG_FUNCTION_LAN_DESCRIPTION_LAN2 = "CONFIG_FUNCTION_LAN_DESCRIPTION_LAN2",
    CONFIG_FUNCTION_VPN_EOIP = "CONFIG_FUNCTION_VPN_EOIP",
    CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING = "CONFIG_FUNCTION_VPN_IPSEC_KEEPALIVE_PING",
    CONFIG_FUNCTION_DUAL_WAN = "CONFIG_FUNCTION_DUAL_WAN",
    CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY = "CONFIG_FUNCTION_DUAL_WAN_FAILOVER_AND_PRIORITY",
    CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE = "CONFIG_FUNCTION_DUAL_WAN_OUT_BOUND_LOAD_BALANCE",
    CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH = "CONFIG_FUNCTION_DUAL_WAN_PROBE_BY_SIGNAL_STRENGTH",
    CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING = "CONFIG_FUNCTION_DUAL_WAN_PROTOCOL_BINDING",
    CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER = "CONFIG_FUNCTION_DUAL_WAN_SMART_WIFI_CONTROLLER",
    CONFIG_FUNCTION_PCI_LOCK = "CONFIG_FUNCTION_PCI_LOCK",
    CONFIG_FUNCTION_LTE_TX_POWER = "CONFIG_FUNCTION_LTE_TX_POWER",
    CONFIG_FUNCTION_RGOOSE = "CONFIG_FUNCTION_RGOOSE",
    CONFIG_FUNCTION_MULTIPL_BAND_SELECT = "CONFIG_FUNCTION_MULTIPL_BAND_SELECT",
    CONFIG_FUNCTION_IP_PASSTHROUGH = 'CONFIG_FUNCTION_IP_PASSTHROUGH',
    CONFIG_FUNCTION_PLMN_SELECTION = 'CONFIG_FUNCTION_PLMN_SELECTION',
    CONFIG_FUNCTION_NB_IOT = 'CONFIG_FUNCTION_NB_IOT',
    CONFIG_FUNCTION_DUAL_APN = 'CONFIG_FUNCTION_DUAL_APN',
    CONFIG_FUNCTION_PDN_TYPE = 'CONFIG_FUNCTION_PDN_TYPE',
    CONFIG_FUNCTION_LEVEL_2_RECOVERY = 'CONFIG_FUNCTION_LEVEL_2_RECOVERY',
    CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY = 'CONFIG_FUNCTION_SYSTEM_REBOOT_RECOVERY',
    CONFIG_FUNCTION_IPV6_464XLAT = 'CONFIG_FUNCTION_IPV6_464XLAT',

    // OpenWRT Device Config Function
    OPENWRT_CONFIG_FUNCTION_SIM_SELECTION = "OPENWRT_CONFIG_FUNCTION_SIM_SELECTION",
    OPENWRT_CONFIG_FUNCTION_WAN_USAGE = "OPENWRT_CONFIG_FUNCTION_WAN_USAGE",
    OPENWRT_CONFIG_FUNCTION_SPEED_TEST_SERVER_CUSTOMIZE = "OPENWRT_CONFIG_FUNCTION_SPEED_TEST_SERVER_CUSTOMIZE",

    // Customize Device Model
    CDM_SCE_MX_220_UT_5G = "CDM_SCE_MX_220_UT_5G"
};

export type FeaturesProfile = Array<DeviceFeatures>;

export type ModelFeaturesMap = {
    [key in SupportDeviceModel]: FeaturesProfile;
};

export enum DeviceCategory {
    ROUTER = "ROUTER",
    REMOTE_POWER_SWITCH = "REMOTE_POWER_SWITCH",
    OUT_SOURCING_DEVICE = "OUT_SOURCING_DEVICE"
};